import { useEffect } from 'react'
import { image } from '../../../../utils/data/baseUrl'
import { useModalsDataActions } from '../../../../hooks/useModalsDataActions'
import { IMAGE, TITLE, TEXT, BUTTONS } from '../../../../components/modals/universalModal'
import { CUSTOMIZATION } from '../../../../constants/shared/states/names'
import useStateControls from '../../../../hooks/useStateControls'

const SPRING_MODAL_END_DATE = new Date('2026-05-24T23:59:59')

export function useSpringModal({ key, isTruthState, isAvailable, isCanShow, set }) {
  const { addModal } = useModalsDataActions()
  const { setState } = useStateControls()

  useEffect(() => {
    const storage = typeof window !== 'undefined' ? window.sessionStorage : null

    if (!isAvailable) return
    if (!isCanShow) {
      set(key, false)
      return
    }
    if (!isTruthState) return
    if (Date.now() > SPRING_MODAL_END_DATE.getTime()) return
    if (!storage) return

    const sessionKey = `${key}SessionFlag`
    const isReadyToShow = storage.getItem(sessionKey) === 'true'

    if (!isReadyToShow) {
      storage.setItem(sessionKey, 'true')
      return
    }

    addModal(createModal(setState))
    set(key, true)
    storage.removeItem(sessionKey)
  }, [key, isAvailable, isTruthState, isCanShow, set, addModal, setState])
}

function createModal(setState) {
  return {
    type: 'universalModal',
    props: {
      modalProps: {
        wrapper: { isFullPage: false },
        modifier: ['noFullNoScroll', 'width-image-full'],
      },
      components: [
        {
          list: [
            {
              type: IMAGE,
              props: {
                modifier: 'width-full',
                img: image('modals/spring.png'),
              },
            },
            {
              type: TITLE,
              props: {
                modifier: 'padding-no',
                value: 'springModalContent.title',
              },
            },
            {
              type: TEXT,
              props: {
                value: 'springModalContent.description',
              },
            },
            {
              type: BUTTONS,
              props: {
                buttons: [
                  {
                    text: 'other.want',
                    disposable: true,
                    customCallbacks: { setState },
                    callbackKey: 'setState',
                    callbackOptions: CUSTOMIZATION,
                    modalData: {
                      action: 'close',
                      data: { type: 'current' },
                    },
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  }
}
